import { promoteOrganisationRole } from '@infuse/api/iam/organisation';
import { useGenericPromoteRole } from '@infuse/iam/role/mutations';

export const usePromoteOrganisationRole = () => {
  return useGenericPromoteRole({
    apiFn: promoteOrganisationRole
  });
};
